/**
 * «Деньги: путь рубля» — одна полоса KPI слева направо повторяет путь рубля
 * от потенциала к кэшу: Pipeline → Договоры → Получено → Ждём 2-й транш.
 * «Ждём 2-й транш» кликабелен — скроллит к списку sla/no_next_step.
 */

import { Banknote, FileSignature, Layers, PiggyBank, Tag, Wallet } from 'lucide-react'
import { KpiCard } from './primitives'
import { formatRub } from '@/lib/utils'
import type { DashboardMoney } from '@/types'

function scrollToHot() {
  const el = document.getElementById('sla-list') ?? document.getElementById('no-step-list')
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function MoneyBand({ money }: { money: DashboardMoney }) {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6">
      <KpiCard
        label="Деньги в работе (pipeline)"
        value={formatRub(money.pipeline_value)}
        icon={Layers}
        accent="primary"
        sub="весь потенциал воронки"
      />
      <KpiCard
        label="Договоры подписаны"
        value={formatRub(money.won_contracts_total)}
        icon={FileSignature}
        accent="neutral"
        sub="законтрактовано"
      />
      <KpiCard
        label="Предоплаты получены"
        value={formatRub(money.prepaid_received)}
        icon={PiggyBank}
        accent="green"
        sub="живые деньги на счёте"
      />
      <KpiCard
        label="Ждём 2-й транш"
        value={formatRub(money.awaiting_second_tranche)}
        icon={Wallet}
        accent="amber"
        sub="дозабрать — нажмите"
        onClick={scrollToHot}
      />
      <KpiCard
        label="Средний чек"
        value={formatRub(money.avg_check)}
        icon={Tag}
        accent="neutral"
        sub="типовая сделка"
      />
      <KpiCard
        label="Допродажи (апсейлы)"
        value={formatRub(money.upsells_total)}
        icon={Banknote}
        accent="neutral"
        sub="сверх договора"
      />
    </div>
  )
}
